<script setup>
// import Navbar from '@/components/NavbarView.vue';
import { ref, onMounted, defineProps, computed, reactive } from 'vue';
import { ElMessage } from 'element-plus';
import request from '@/utils/request';
// import { iconMenu } from '@element-plus/icons-vue';
import { ArrowDown, EditPen, Delete } from '@element-plus/icons-vue'
import { getUsersListApi, getSchoolDictList, updateSchoolDict, batchAddUsers } from '@/utils/api';
import Pagination from '@/components/CustomPagination.vue';
import { usePageTransferStore } from '@/store/pageTransferStore'
const pageTransferStore = usePageTransferStore()

const admin_level = JSON.parse(localStorage.getItem('user')).admin_level;

// 接收父组件传递的用户角色
const props = defineProps({
  userRole: {
    type: String,
    required: true,
    default: 'student',
    validator: (value) => {
      return ['student', 'reviewer', 'admin'].includes(value);
    }
  }
});

// 状态管理
const results = ref([
  {
    username: 'student',
    name: '学生1',
  }
]);
const loading = ref(false);
const dialogVisible = ref(false);
const selectedProject = ref(null);
const editVisible = ref(false);
const title = ref('');
const operation = ref('');

// 新增：搜索框绑定变量
const searchUsername = ref(''); // 用户名搜索
const searchRealName = ref('');  // 姓名搜索

const currentUserID = ref('');
const editUser = (user) => {
  console.log('user', user);
  addForm.username = user.username;
  addForm.name = user.real_name;
  addForm.user_type = user.user_type;
  addForm.number = user.number;
  addForm.faculty = user.faculty;
  addForm.grade = user.grade;
  addForm.class = user.classid;
  addForm.institution = user.institution;
  addForm.gender = user.gender; // 直接回显数字 0/1
  editVisible.value = true;
  title.value = '编辑用户';
  operation.value = 'edit';
  currentUserID.value = user.user_id;
};

const currentRole = ref('student'); 
const formRef = ref(null);
// 表单数据
const addForm = reactive({
  username: '',    // 用户名（通用）
  password: '',    // 密码（通用）
  user_type: '',    // 角色（通用）
  name: '',    // 姓名（仅学生）
  number: '',    // 学号/工号
  faculty: '',    // 学部（仅学生）
  grade: '',    // 年级（仅学生）
  class: '',    // 班级（仅学生）
  institution: '',    // 负责区域（仅评审员）
  gender: '', // 存储数字 0/1
});

// 批量上传专用 loading
const uploadLoading = ref(false);

const roleConfig = computed(() => {
  const configs = {
    student: {
      title: '添加用户',
      usernamePlaceholder: '请输入用户名',
      apiUrl: '/auth/student/login',
      redirectPath: '/upload',
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: operation.value === 'add', message: '请输入密码', trigger: 'blur' }
        ],
        user_type: [
          { required: true, message: '请选择角色', trigger: 'change' }
        ],
        gender: [
          { required: addForm.user_type === 'student', message: '请选择性别', trigger: 'change' }
        ],
        faculty: [
          { required: addForm.user_type === 'student', message: '请选择学部', trigger: 'change' }
        ],
        grade: [
          { required: addForm.user_type === 'student', message: '请选择年级', trigger: 'change' }
        ],
        number: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        class: [
          { required: addForm.user_type === 'student', message: '请输入班级', trigger: 'blur' }
        ],
        institution: [
          { required: admin_level === 1, message: '请选择负责区域', trigger: 'change' }
        ],
        empId: [
          { required: addForm.user_type === 'employee', message: '请输入工号', trigger: 'blur' }
        ]
      }
    },
    reviewer: {
      title: '评审员登录',
      usernamePlaceholder: '请输入评审员ID',
      apiUrl: '/auth/reviewer/login',
      redirectPath: '/review',
      rules: {
        username: [
          { required: true, message: '请输入评审员ID', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      }
    },
    admin: {
      title: '管理员登录',
      usernamePlaceholder: '请输入管理员ID',
      apiUrl: '/auth/admin/login',
      rules: {
        username: [
          { required: true, message: '请输入管理员ID', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      }
    }
  };
  return configs[currentRole.value];
});

// 处理添加用户
const handleAddUser = () => {
  // 跳转到添加用户页面
  editVisible.value = true;
  title.value = '添加用户';
  operation.value = 'add';
};

const getSchoolList = () => {
  getSchoolDictList().then(res => {
    if(res.success){
      schools.value = res.data
    }
  })
}

const generatePassword = () => {
  // 生成随机密码
  const randomPassword = Math.random().toString(36).slice(-8);
  addForm.password = randomPassword;
};

const handleRoleChange = () => {
  addForm.number = '';
  addForm.faculty = ''; 
  addForm.grade = '';    
  addForm.class = '';
  addForm.gender = ''; // 切换角色清空性别
}

const submitAddUser = async () => {
  if (addForm.gender === '') addForm.gender = null;
  if (addForm.gender != null) addForm.gender = Number(addForm.gender);

  try {
    await formRef.value.validate();
  } catch (error) {
    console.log('验证失败:', error);
    ElMessage.error('请填写完整信息');
    return;
  }

  try {
    if(operation.value === 'add'){
      await request.post('/auth/users/create', addForm);
      ElMessage.success('用户添加成功');
    }else if(operation.value === 'edit'){
      await request.post('/auth/users/update', {
        ...addForm,
        user_id: currentUserID.value
      });
      ElMessage.success('用户编辑成功');
    }
    editVisible.value = false;
    handleSearch()
  } catch (error) {
    console.log('操作失败，保持对话框打开状态');
  }

}

const handleReset = () => {
  addForm.username = '';
  addForm.password = '';
  addForm.user_type = '';
  addForm.name = '';
  addForm.studentId = '';
  addForm.faculty = '';
  addForm.grade = '';
  addForm.class = '';
  addForm.institution = '';
  addForm.empId = '';
  addForm.gender = ''; // 重置清空性别
}

// 根据分数获取标签类型
const getScoreType = (score) => {
  if (score >= 90) return 'success';
  if (score >= 80) return 'primary';
  if (score >= 70) return 'warning';
  return 'danger';
};

const activeName = ref('student');
const handleClick = (tab) => {
  console.log(tab)
  console.log('activeName:',activeName.value)
};

const roleName = ref('');
const roleOptions = ref([
  {
    value: '',
    label: '全部'
  },
  {
    value: 'student',
    label: '学生'
  },
  {
    value: 'employee',
    label: '教师'
  },
    {
    value: 'reviewer',
    label: '评委'
  },
  {
    value: 'admin',
    label: '管理员'
  }
]);

// 删除用户
const deleteUser = async (user) => {
  console.log('删除用户:', user);
    await request.post(`/auth/users/delete`, {
      user_id: user.user_id
    });
    ElMessage.success('用户删除成功');
    handleSearch()
};

const pagination = ref({
  page: 1,
  pages: 3,
  per_page: 10,
  total: 7
})

// 组件挂载时加载数据
onMounted(()=>{
  handleSearch();
  getSchoolList();
});

const onSearch = () => {
  pagination.value.page = 1
  handleSearch()
}

// 修改：搜索接口传入 用户名+姓名 参数
const handleSearch = () => {
  getUsersListApi({
    page: pagination.value.page,
    per_page: pagination.value.per_page,
    user_type: roleName.value,
    username: searchUsername.value,
    real_name: searchRealName.value
  }).then(res => {
    // 安全判断：必须有 data 才继续
    if (!res || !res.data) {
      console.warn('接口返回数据异常', res)
      // 给默认值，防止报错
      results.value = []
      pagination.value.total = 0
      pageTransferStore.setDataOverviewList({
        ...pageTransferStore.getDataOverviewList,
        users: 0
      })
      return
    }

    // 正常赋值
    results.value = res.data.users || []
    // 关键修复：pagination 不存在就给默认空对象
    pagination.value = res.data.pagination || { total: 0 }

    pageTransferStore.setDataOverviewList({
      ...pageTransferStore.getDataOverviewList,
      users: pagination.value.total || 0,
    })

    console.log('getDataOverviewList:', pageTransferStore.getDataOverviewList)
    
  }).catch(err => {
    // 捕获接口异常，防止“未处理的Promise拒绝”
    console.error('获取用户列表失败：', err)
    results.value = []
    pagination.value.total = 0
    pageTransferStore.setDataOverviewList({
      ...pageTransferStore.getDataOverviewList,
      users: 0
    })
  })
}

const handlePageChange = (page) => {
  pagination.value.page = page;
  handleSearch();
}

const schools = ref([
  {
    value: '1',
    label: '清华大学'
  },
  {
    value: '2',
    label: '北京大学'
  },
  {
    value: '3',
    label: '中国人民大学'
  }
])

const isAdding = ref(false);
const optionName = ref('')
const onAddOption = () => {
  isAdding.value = true
}

const onConfirm = () => {
  console.log('添加学校onConfirm', optionName.value)
  if (optionName.value) {
    updateSchoolDict({
      name: optionName.value,
    }).then(res => {
      if(res.success){
        ElMessage.success('添加学校成功')
        getSchoolList()
      }else{
        ElMessage.error('添加学校失败')
      }
    })
    clear()
  }
}

const clear = () => {
  optionName.value = ''
  isAdding.value = false
}

// 修复：批量上传（只加 loading + 解决重复上传）
const customUpload = (fileData) => {
  uploadLoading.value = true;
  console.log('handleFileChange', fileData)
  const formData = new FormData()
  formData.append('excel_file', fileData.file)
  batchAddUsers(formData).then(res=>{
    ElMessage.success(res.message)
    handleSearch()
    editVisible.value = false
  }).finally(() => {
    uploadLoading.value = false;
  })
};
</script>

<template>
  <div class="container">
    <div class="results-container">
      <div class="top">
        <!-- 修改：搜索区域布局，新增用户名、姓名搜索框 -->
        <div class="search-group">
          <div class="search-item">
            <div class="label">角色：</div>
            <el-select v-model="roleName" placeholder="请选择" size="small"  style="width: 120px;">
              <el-option
                v-for="item in roleOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div>

          <div class="search-item">
            <div class="label">用户名：</div>
            <el-input 
              v-model="searchUsername" 
              placeholder="请输入用户名" 
              size="small"
              clearable
            ></el-input>
          </div>

          <div class="search-item">
            <div class="label">姓名：</div>
            <el-input 
              v-model="searchRealName" 
              placeholder="请输入姓名" 
              size="small"
              clearable
            ></el-input>
          </div>

          <el-button type="primary" @click="onSearch" size="small">搜索</el-button>
        </div>
        
        <el-button type="primary" @click="handleAddUser" size="default">添加用户</el-button>
      </div>

      <el-table :data="results" border class="activity-table" :scrollbar-always-on="true"
        style="width: 100%;margin-top: 20px;" v-loading="loading">
        <el-table-column prop="username" label="用户名"></el-table-column>
        <el-table-column prop="user_type" label="角色">
          <template #default="scope">
            {{ roleOptions.find(item => item.value === scope.row.user_type)?.label || '无' }}
          </template>
        </el-table-column>
        <el-table-column prop="institution" label="归属机构/学校">
          <template #default="scope">
            {{ schools.find(item => item.id === scope.row.institution)?.name || '无' }}
          </template>
        </el-table-column>
        <el-table-column prop="real_name" label="姓名"></el-table-column>
        <el-table-column label="操作">
          <template #default="scope">
            <el-button type="text" :icon="EditPen" @click="editUser(scope.row)">编辑</el-button>
            <el-popconfirm title="确定删除这个用户吗?" @confirm="deleteUser(scope.row)">
              <template #reference>
                <el-button text :icon="Delete" type="danger">删除</el-button>
              </template>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>

      <!-- 详情对话框 -->
      <el-dialog 
        title="评审详情" 
        :model-value="dialogVisible"
        :width="userRole === 'admin' ? '70%' : '50%'"
        @update:model-value="(visible) => dialogVisible = visible"
      >
        <div v-if="selectedProject" class="project-details">
          <h3>{{ selectedProject.projectName }}</h3>
          <p><strong>作者：</strong>{{ selectedProject.author }}</p>
          <p><strong>提交时间：</strong>{{ selectedProject.submitTime }}</p>
          <p><strong>最终得分：</strong>
            <el-tag 
              :type="getScoreType(selectedProject.score)"
              size="medium"
            >
              {{ selectedProject.score }}
            </el-tag>
          </p>
          
          <div class="review-content">
            <h4>评审意见：</h4>
            <p>{{ selectedProject.reviewContent }}</p>
          </div>
          
          <div v-if="userRole === 'admin'" class="all-reviews">
            <h4>所有评审记录：</h4>
            <el-timeline>
              <el-timeline-item 
                v-for="(review, index) in selectedProject.allReviews" 
                :key="index"
                :timestamp="review.reviewDate"
              >
                <el-card>
                  <h5>{{ review.reviewer }} ({{ review.score }})</h5>
                  <p>{{ review.content }}</p>
                </el-card>
              </el-timeline-item>
            </el-timeline>
          </div>
        </div>
      </el-dialog>

      <el-dialog 
        :title="title" 
        :model-value="editVisible"
        width="40%"
        @update:model-value="(visible) => {
          editVisible = visible
          handleReset()
        }"
      >
        <div class="login-container">
          <div class="login-card">

            <div class="login-top">
              <el-upload
                class="avatar-uploader"
                action="/api/upload"
                :limit="1"
                :show-file-list="false"
                :accept="'.xlsx'"
                :http-request="customUpload"
              >
                <el-button size="default" type="primary" :loading="uploadLoading">批量添加学生</el-button>
              </el-upload>
              <a href="/stu_regi_template.xlsx" download>模板下载</a>
            </div>
            <el-form ref="formRef" :model="addForm" :rules="roleConfig.rules" label-width="25%" class="login-form">
              
              <el-form-item label="用户名" prop="username">
                <el-input v-model="addForm.username" :placeholder="roleConfig.usernamePlaceholder"
                  style="width:60%"
                ></el-input>
              </el-form-item>
              
              <el-form-item label="初始密码" prop="password">
                <div class="password-row">
                  <el-input v-model="addForm.password" placeholder="请输入密码" style="width:60%"></el-input>
                  <el-button type="primary" @click="generatePassword">生成随机密码</el-button>
                </div>
              </el-form-item>

              <!-- 关键修改：编辑时角色置灰 -->
              <el-form-item label="角色" prop="user_type">
                <el-select 
                  v-model="addForm.user_type" 
                  placeholder="请选择角色" 
                  @change="handleRoleChange"
                  style="width:60%"
                  :disabled="operation === 'edit'"
                >
                  <el-option label="管理员" value="admin"></el-option>
                  <el-option label="教师" value="employee"></el-option>
                  <el-option label="学生" value="student"></el-option>
                </el-select>
              </el-form-item>
              
              <el-form-item :label="addForm.user_type === 'student' ? '学号' : '工号'" prop="number" v-if="addForm.user_type === 'student' || addForm.user_type === 'employee'">
                <el-input v-model="addForm.number" 
                  placeholder="请输入" style="width:60%"
                ></el-input>
              </el-form-item>
              
              <el-form-item label="学部" prop="faculty" v-if="addForm.user_type === 'student'">
                <el-select v-model="addForm.faculty" placeholder="请选择学部" style="width:60%">
                  <el-option label="小学" value="小学"></el-option>
                  <el-option label="初中" value="初中"></el-option>
                  <el-option label="高中" value="高中"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="年级" prop="grade" v-if="addForm.user_type === 'student'">
                <el-select v-model="addForm.grade" placeholder="请选择年级" style="width:60%">
                  <el-option label="1" value="1"></el-option>
                  <el-option label="2" value="2"></el-option>
                  <el-option label="3" value="3"></el-option>
                  <el-option label="4" value="4"></el-option>
                  <el-option label="5" value="5"></el-option>
                  <el-option label="6" value="6"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="班级" prop="class" v-if="addForm.user_type === 'student'">
                <el-input v-model="addForm.class" type="number"
                  placeholder="请输入班级" style="width:60%"
                ></el-input>
              </el-form-item>

              <!-- 修复：下拉框使用数字 0/1 -->
              <el-form-item label="性别" prop="gender" v-if="addForm.user_type === 'student'">
                <el-select v-model="addForm.gender" placeholder="请选择性别" style="width:60%">
                  <el-option label="男" :value="0"></el-option>
                  <el-option label="女" :value="1"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="归属机构" prop="institution" v-if="admin_level === 1">
                <el-select v-model="addForm.institution" placeholder="请选择归属机构" filterable style="width:60%">
                  <el-option v-for="item in schools" :key="item.id" :label="item.name" :value="item.id"/>
                  <template #footer>
                    <el-button v-if="!isAdding" text bg size="small" @click="onAddOption">
                      添加机构
                    </el-button>
                    <template v-else>
                      <el-input v-model="optionName" class="option-input" placeholder="输入机构名字" size="small"/>
                      <el-button type="primary" size="small" @click="onConfirm">确认</el-button>
                      <el-button size="small" @click="clear">取消</el-button>
                    </template>
                  </template>
                </el-select>
              </el-form-item>
              
              <el-form-item label="姓名">
                <el-input 
                  v-model="addForm.name" 
                  placeholder="请输入姓名" style="width:60%"
                ></el-input>
              </el-form-item>
              
              <el-form-item>
                <el-button type="primary" class="login-btn" @click="submitAddUser" :loading="loading">
                  确定
                </el-button>
                <el-button class="login-btn" @click="handleReset" :loading="loading">
                  重置
                </el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-dialog>

      <el-dialog title="批量添加学生" :model-value="batchAddVisible" width="40%"
        @update:model-value="(visible) => batchAddVisible = visible">
        <el-form ref="batchFormRef" :model="batchAddForm" :rules="batchRules" label-width="25%" class="login-form">
          <a href="/template.docx" download>模板下载</a>
          <el-form-item label="学生信息" prop="students">
            <el-upload
              class="avatar-uploader"
              action="/api/upload"
              :show-file-list="false"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
            <div v-if="batchAddForm.students.length > 0" class="avatar-preview">
              <img v-for="(item, index) in batchAddForm.students" :key="index" :src="item.avatar" alt="学生头像" style="width: 50px; height: 50px; margin-right: 5px;">
            </div>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
  </div>
  <Pagination :pagination="pagination" @current-change="handlePageChange" />
</template>

<style scoped>
.container{
  height: calc(100vh - 140px);
  overflow-y: auto;
}

.results-container {
  padding: 20px;
  padding-bottom: 0;
}

.top{
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

/* 新增：搜索框样式 */
.search-group{
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}
.search-item{
  display: flex;
  align-items: center;
  gap: 6px;
}
.label{
  white-space: nowrap;
}

.activity-table{
  height: calc(100vh - 220px);
}

.project-details {
  line-height: 1.8;
}

.review-content {
  margin: 15px 0;
  padding: 10px;
  background-color: #f5f7fa;
  border-radius: 4px;
}

.all-reviews {
  margin-top: 20px;
}

.el-timeline {
  margin-top: 10px;
}

.login-title {
  text-align: center;
  font-size: 24px;
  font-weight: 600;
  color: #165DFF;
  margin-bottom: 30px;
}

.password-row {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
}

.login-form {
  margin-top: 20px;
}

.login-btn {
  width: 40%;
  height: 35px;
  font-size: 16px;
  margin-top: 20px;
}

.el-dropdown-link {
  cursor: pointer;
  color: var(--el-color-primary);
  display: flex;
  align-items: center;
}

.option-input {
  width: 100%;
  margin-bottom: 10px;
}

.login-top{
  margin-bottom: 30px;
  margin-right: 20px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
}
</style>